<template>
  <div class="highlights-display-title">
    <span class="display-title">Título de exibição</span>
    <mf-textarea-emoji
      v-model="value"
      hide-details
      outlined
      no-resize
      background-color="white"
      height="50"
      :max-length="25"
      counter
      :disabled="disabled"
      :error="error"
      :error-messages="getErrorMessage"
    />
  </div>
</template>
<script>
import { highlightOffer } from '../../../../mixins/highlight-offer'

export default {
  name: 'DisplayTitle',
  mixins: [highlightOffer],
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    error: {
      type: Boolean,
      default: false,
    },
    errorMessage: {
      type: String,
      default: '',
    },
  },
  data: () => ({}),
  computed: {
    value: {
      set(value) {
        this.setHighlightKeyValue({ payload: value, key: 'displayTitle' })
      },
      get() {
        return this.highlightDisplayTitle
      },
    },
    getErrorMessage() {
      return this.error ? this.errorMessage : ''
    },
  },
}
</script>
<style lang="scss" scoped>
.highlights-display-title {
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
  max-width: 574px;
  .display-title {
    color: $cinza-d10;
    font-family: Lato;
    font-size: 18px;
    font-style: normal;
    font-weight: 700;
    line-height: 120%;
  }
}
::v-deep .v-input__append-inner {
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 0 !important;
}
</style>
